<!-- =========================================================================================
    File Name: UserListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <vx-card title="DNA">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

    <div class="vx-row mb-2" v-if="dnaKit" >
      <div class="vx-col w-full">

        <vs-table data="_">
          <vs-tr>
            <vs-td>Kit Id:</vs-td>
            <vs-td>{{ dnaKit.kitId }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Status:</vs-td>
            <vs-td>{{ dnaKit.status }} - {{ dnaKit.statusDate }}</vs-td>
          </vs-tr>
          <vs-tr v-if="dnaKit.tracking">
            <vs-td>USPS Tracking:</vs-td>
            <vs-td>{{ dnaKit.tracking }}</vs-td>
          </vs-tr>
          <vs-tr v-if="geneticReport">
            <vs-td>
              Trait Count:
            </vs-td>
            <vs-td>{{ dnaKit.traitCount }}</vs-td>
          </vs-tr>
          <vs-tr v-if="dnaKit.purchasedReports">
            <vs-td>Available Reports:</vs-td>
            <vs-td v-if="dnaKit.purchasedReports.length">{{ dnaKit.purchasedReports.join(", ") }}</vs-td>
            <vs-td v-else>No Purchased Reports</vs-td>
          </vs-tr>
        </vs-table>

        <vs-collapse v-if="ggKit && ggKit.statusLogs" type="border" class="mt-1 mb-6" >
          <vs-collapse-item >
            <div slot="header" >
              Status History
            </div>
            <vs-table data="___" v-if="ggKit.statusLogs.length">
              <vs-tr v-for="(statusLog,index) in ggKit.statusLogs" :key="index">
                <vs-td>{{statusLog.status}}</vs-td>
                <vs-td>{{statusLog.statusAt}}</vs-td>
              </vs-tr>
            </vs-table>
          </vs-collapse-item>
        </vs-collapse>

      </div>
    </div>

    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <h5>Old Kits</h5>
      </div>
    </div>

    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-table data="__" v-if="oldKits.length">
          <vs-tr v-for="dnaKit in oldKits" :key="dnaKit.kitId">
            <vs-td>{{dnaKit.kitId}}</vs-td>
            <vs-td>{{dnaKit.status.toUpperCase()}}</vs-td>
            <vs-td>{{dnaKit.statusAt}}</vs-td>
          </vs-tr>
        </vs-table>
      </div>
    </div>

    <vs-collapse type="border" class="mt-1 mb-6" >
      <vs-collapse-item >
        <div slot="header" >
          Purchased Kits
        </div>
        <vs-list v-if="purchasedKits">
            <vs-list-header :title="`Order ${purchasedKits.orderNumber}`"></vs-list-header>
            <vs-list-item v-if="purchasedKits.dnaKits.length" title="Order Date" :subtitle="`${purchasedKits.orderDate}`"></vs-list-item>
            <vs-list-item title="ShipStation Order" :subtitle="`${purchasedKits.shipStationOrderId}`"></vs-list-item>
            <vs-list-item v-if="purchasedKits.shipTo" title="Ship To" :subtitle="purchasedKits.shipTo.email"></vs-list-item>
            <vs-list-item v-if="purchasedKits.dnaKits.length" title="Kit Ids" :subtitle="purchasedKits.dnaKits.join(', ')"></vs-list-item>
        </vs-list>
      </vs-collapse-item>
    </vs-collapse>



  </vx-card>
</template>

<script>
import dnaApi from "@/http/dnaApi";

export default {
  data() {
    return {
      /** @type FullDnaKit */
      dnaKit: null,
      loading: false,
      /** @type GGKit */
      ggKit: null,
      /** @type GeneticReport */
      geneticReport: null,
      /** @type PurchasedKits */
      purchasedKits: null,
      oldKits: [],
      showHistoryDialog: false
    }
  },
  props: {
    userId: {
      required: true,
    },
  },
  mounted() {
    this.fetchKit();
  },
  watch: {
  },
  computed: {
  },
  methods: {
    async fetchKit() {
      this.loading = true;

      try {

        this.dnaKit = await dnaApi.getKitByUserId(this.userId);

        if (this.dnaKit) {
          this.ggKit = await dnaApi.getGGKit(this.dnaKit.kitId);
          this.purchasedKits = await dnaApi.getPurchasedKits(this.dnaKit.kitId);
        }

        let gdKits = [];

        if (this.ggKit) {
          this.geneticReport = await dnaApi.getGeneticReport(this.ggKit.geneticReportIds[0]);
          gdKits = await dnaApi.getGdKits(this.ggKit.personId);
        }

        const oldKits = await dnaApi.getKitOldKits(this.userId);

        const filteredGdKits = gdKits.filter((kit) => {
          if(this.dnaKit.kitId && kit.kitId === this.dnaKit.kitId) return false;
          if(oldKits.filter((oldKit) => oldKit.kitId === kit.kitId).length) return false;
          return true;
        });

        this.oldKits = oldKits.concat(filteredGdKits);

      } catch (e) {
        console.log(e);
      }

      this.loading = false;
    },

    showHistory() {
      this.showHistoryDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
